export default __webpack_public_path__ + "static/media/bellhop.a6c41102.png";